import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'components/Icon'
import ContextMenuItem from 'components/Navigation/ContextMenu/ContextMenuItem/ContextMenuItem'

import './events-nav-menu-item.pcss'

class EventsNavMenuItem extends React.PureComponent {
    render () {
        const { wrappedEvent, children, onSelect, trackName } = this.props

        return (
            <ContextMenuItem
                className="events-nav-menu-item"
                onSelect={onSelect}
                trackName={trackName}
            >
                <Icon
                    fa
                    color="white"
                    name={wrappedEvent.icon}
                    shape="circle"
                    size="s"
                    style={{ backgroundColor: wrappedEvent.color }}
                />
                <span>{children}</span>
            </ContextMenuItem>
        )
    }
}

EventsNavMenuItem.propTypes = {
    children: PropTypes.node.isRequired,
    onSelect: PropTypes.func.isRequired,
    trackName: PropTypes.string.isRequired,
}

export default EventsNavMenuItem
